import { RootStore } from 'store'

export const faqSelector = (state: RootStore) => state.faq.items
